import type { ConfigStatus } from "../PurchaseOverlay/views";

/**
 * What the basket checkout shows before anything payable (pure, for the
 * tests):
 *
 * - `"loading"`: the school's checkout settings haven't arrived. Whether it
 *   asks for a sign-in, its terms and its currency all come from them, so
 *   nothing is offered yet.
 * - `"error"`: they couldn't be had — an error with Try again. Never "no
 *   sign-in needed": until B3 a failed settings call read as exactly that,
 *   and a school that requires a sign-in let a signed-out buyer pay.
 * - `"sign-in"`: the school asks for a sign-in and the buyer hasn't (a
 *   basket of gift cards alone is exempt, as on the hosted widget).
 * - `"open"`: the checkout.
 */
export type BasketCheckoutGate = "loading" | "error" | "sign-in" | "open";

export function basketCheckoutGate({
  config,
  requireLogin,
  isLoggedIn,
  hasGateableItem,
}: {
  config: ConfigStatus;
  requireLogin: boolean;
  isLoggedIn: boolean;
  /** Anything in the basket but gift cards. */
  hasGateableItem: boolean;
}): BasketCheckoutGate {
  if (config === "loading") return "loading";
  if (config === "error") return "error";
  // shouldGateCheckout's rule; this checkout always has a way to sign in
  // (its own dialog), so the gate never fails open for want of one.
  return hasGateableItem && requireLogin && !isLoggedIn ? "sign-in" : "open";
}
